import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import India from "../Images/Icons/India.png";
import Usa from "../Images/Usa.png";
import Germany from "../Images/Germany.png";
import Australia from "../Images/Australia.png";
import Logo from "../Images/Logow.png";
import Canada from "../Images/Canada.png";
import { Link } from "react-router-dom";
const locations = [
  {
    country: "INDIA",
    icon: India,
    address: " Surat Gujarat, 395006",
  },
  {
    country: "USA",
    icon: Usa,
    address: "Indianapolis, Indiana, USA, 46218",
  },
  {
    country: "GERMANY",
    icon: Germany,
    address: "Weingarten, Germany, 76356",
  },
  {
    country: "AUSTRALIA",
    icon: Australia,
    address: "Melbourne, Australia, 8002",
  },
  {
    country: "CANADA",
    icon: Canada,
    address: "Halifax, Nova scotia, Canada, 902",
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0b1220] text-white pt-10 relative">
      {/* Locations Section */}
      <div className="flex flex-wrap justify-center gap-6 px-6">
        {locations.map((location, index) => (
          <div
            key={index}
            className="bg-[#FFFFFF33] border-white border rounded-xl p-6 text-center w-64 hover:scale-105 transition"
          >
            <div className="flex justify-center items-center">
              <img
                src={location.icon}
                alt=""
                className="h-[80px] object-cover"
              />
            </div>
            <h3
              className="font-bold text-[24px] mt-2"
              style={{ fontFamily: "PT Sans" }}
            >
              {location.country}
            </h3>
            <p className="text-sm text-gray-300 mt-2 font-[Nunito]">
              {location.address}
            </p>
          </div>
        ))}
      </div>

      {/* Footer Section */}
      <div className="mt-12 border-t border-gray-700 py-10 px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {/* Company Info */}
          <div>
            {/* <h3 className="text-xl font-semibold">Godhani Technology</h3> */}
            <Link to={"/"}>
              {" "}
              <img src={Logo} alt="" />
            </Link>
            <p className="text-sm text-white font-[Nunito] mt-2">
              At Godhani Technology, we bring your ideas to life with
              cutting-edge IT solutions that drive innovation and growth.
            </p>
            {/* Social Media */}
            <div className="flex gap-3 mt-4">
              <div className="p-2 bg-[#432DD7] rounded-full cursor-pointer hover:bg-purple-700">
                <a href="https://www.facebook.com/share/16TAk71L5o/">
                  <FaFacebookF />
                </a>
              </div>
              <div className="p-2 bg-[#432DD7] rounded-full cursor-pointer hover:bg-purple-700">
                <a href="https://www.instagram.com/godhani_technology?igsh=b3QxM3plOWFpc2Rs">
                  <FaInstagram />
                </a>
              </div>
              <div className="p-2 bg-[#432DD7] rounded-full cursor-pointer hover:bg-purple-700">
                <a href="https://www.linkedin.com/company/godhani-technology/">
                  <FaLinkedinIn />
                </a>
              </div>
              <div className="p-2 bg-[#432DD7] rounded-full cursor-pointer hover:bg-purple-700">
                <FaTwitter />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-3 font-[Nunito]">
              Quick Links
            </h3>
             <ul className="space-y-2 text-white font-[Nunito] text-sm">
              <li>
                <Link to="/" className="hover:text-white cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/aboutus" className="hover:text-white cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/partnershipwithus"
                  className="hover:text-white cursor-pointer"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/career" className="hover:text-white cursor-pointer">
                  Career
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-3 font-[Nunito]">
              Services
            </h3>
            <ul className="space-y-2 text-white font-[Nunito] text-sm">
              <li className="hover:text-white cursor-pointer">
                Website Development
              </li>
              <li className="hover:text-white cursor-pointer">
                Application Development
              </li>
              <li className="hover:text-white cursor-pointer">
                Software Development
              </li>
              <li className="hover:text-white cursor-pointer">
                AI Development
              </li>
              <li className="hover:text-white cursor-pointer">
                E-commerce Solution
              </li>
              <li className="hover:text-white cursor-pointer">UI/UX Design</li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-3 font-[Nunito]">
              Newsletter
            </h3>
            <p className="text-sm text-white font-[Nunito]">
              Subscribe to our newsletter to receive updates and insights.
            </p>
            <div className="relative mt-4">
              <input
                type="email"
                placeholder="Your email address"
                className="w-full bg-[#FFFFFF33] text-white p-3 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#432DD7] text-white p-2 rounded-full hover:bg-purple-700">
                <IoSend />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex justify-between items-center text-sm text-white font-[Nunito] border-t border-gray-700 mt-10 pt-4 max-w-6xl mx-auto">
          <p>© 2025 Godhani Technology. All rights reserved.</p>
          <div className="flex gap-4 font-[Nunito]">
            <span className="cursor-pointer text-white">Privacy Policy</span>
            <span className="cursor-pointer text-white">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
